import {
  AuthEmail,
  AuthGuest,
  AuthSignUp,
  BaseResponse,
  MfaEnrollResponse,
  MfaChallengeResponse,
} from 'types';

import { URL } from '../constants';
import { apiInstance, apiLoaderInstance } from '../instance';

import {
  Logout,
  ForgotPassword,
  MfaEnrollPayload,
  MfaVerifyPayload,
  MfaChallengePayload,
  CheckVerificationResponse,
} from './types';

export const login = async (payload: AuthEmail) =>
  apiLoaderInstance.post(URL.LOGIN, {
    email: payload.email,
    password: payload.password,
  });

export const loginGuest = async (payload: AuthGuest) =>
  apiLoaderInstance.post(URL.LOGIN_GUEST, {
    ...payload,
    guestId: payload.guestId.trim(),
  });

export const logout = async (data: Logout) =>
  apiLoaderInstance.post(URL.LOGOUT, data);

export const forgotPassword = (data: ForgotPassword) =>
  apiLoaderInstance.post(URL.FORGOT_PASSWORD, data);

export const signUp = async (payload: AuthSignUp) =>
  apiLoaderInstance.post(URL.SIGNUP, payload);

export const mfaEnroll = async (payload: MfaEnrollPayload) =>
  apiLoaderInstance.post<BaseResponse<MfaEnrollResponse>>(
    URL.MFA_ENROLL,
    payload
  );

export const mfaVerify = async (payload: MfaVerifyPayload) =>
  apiLoaderInstance.post(URL.MFA_VERIFY, payload);

export const mfaChallenge = async (payload: MfaChallengePayload) =>
  apiLoaderInstance.post<BaseResponse<MfaChallengeResponse>>(
    URL.MFA_CHALLENGE,
    payload
  );

export const sendEmailVerification = async () =>
  apiLoaderInstance.post(URL.SEND_EMAIL_VERIFICATION);

export const checkEmailVerification = async () =>
  apiInstance.post<BaseResponse<CheckVerificationResponse>>(
    URL.CHECK_EMAIL_VERIFICATION
  );
